import {Component, Input, OnInit} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {OfferBasicItemComponent} from '../../../../components/offer-basic-item/offer-basic-item.component';
import {LanguageService} from '../../../../services/language.service';
import {NextOffersSectionStateService} from '../../../../../core/services/impl/section-services/next-offers/next-offers-section-state.service';
import {OfferRecommendationConfig} from '../../../../../core/models/offer/offer-recommendation-config';
import {OfferRecommendationsService} from '../../../../../core/services/impl/offer-recommendations.service';
import {OfferRecommendation} from '../../../../../core/services/impl/offer-recommendations-api.service';
import {OfferResourceService} from '../../../../../core/services/impl/offer-resource.service';

@Component({
  selector: 'app-offer-recommendation-tile',
  templateUrl: './offer-recommendation-tile.component.html',
  styleUrls: []
})
export class OfferRecommendationTileComponent extends OfferBasicItemComponent implements OnInit {

  @Input() recommendation: OfferRecommendation;

  get offer(): Offer {
    return this.recommendation.offer;
  }

  get config(): OfferRecommendationConfig {
    return this.offerRecommendationsService.getConfig(this.recommendation.recommendationType);
  }

  get cssClassSuffix(): string {
    return this.offerRecommendationsService.getRoleConfig(this.recommendation.recommendationType).cssClassSuffix;
  }

  constructor(resourceService: OfferResourceService,
              language: LanguageService,
              public offersSectionStateService: NextOffersSectionStateService,
              private offerRecommendationsService: OfferRecommendationsService) {
    super(resourceService, language);
  }

  ngOnInit() {
    this.setLogo(this.offer);
    this.createBoxes(this.offer);
    this.setAmount(this.offer);
  }

}
